import React from 'react';
import { useEffect } from "react";
import { Helmet } from 'react-helmet';
import "../../../../assets/css/style.css";
import Form from './Form.js'
import PatientReviews from '../../PatientReview.js';
import GetInTouch from '../../GetInTouch.js';
import FollowYt from '../../FollowYt.js'
import ContentWithImages from './ContentWithImages.js'
import DoctorBite from '../../DoctorBite.js';
import Counter from '../../../NumCounter.js'
import "./style.css"
import Breadcrumb from '../../Breadcrum.js';

export default function Index() {
  useEffect(() => {
    const metaTags = document.getElementsByTagName('meta');
    Array.from(metaTags).forEach((tag) => {
      console.log(tag);
    });
  }, []);
  return (
    <div>
          <Helmet>
            <title>Mastoidectomy Surgery in Delhi, India | Treatment, Cost, Doctor, Clinic </title>
            <meta name="description" content="Get expert mastoidectomy surgery and treatment in Delhi, India at an affordable cost. Advanced ear infection care by experienced ENT specialists for safe recovery." />
            <meta name="keywords" content="Mastoidectomy Surgery in Delhi, Mastoidectomy Surgery, Mastoidectomy Surgery in India, Mastoidectomy surgery recovery time, Mastoidectomy surgery types, Mastoidectomy surgery video, Mastoidectomy surgery cost, Mastoidectomy surgery time, Mastoidectomy surgery Instruments, Mastoidectomy surgery cost in India" />
            <link rel="canonical" href="https://entdelhi.com/mastoidectomy/" />
            <meta property="og:title" content="Mastoidectomy Surgery in Delhi, India | Treatment, Cost, Doctor, Clinic" />
            <meta property="og:description" content="Get expert mastoidectomy surgery and treatment in Delhi, India at an affordable cost. Advanced ear infection care by experienced ENT specialists for safe recovery." />
            <meta name="robots" content="index, follow" />
            {/* You can add more meta tags as needed */}
          </Helmet>
     <main>
        <Breadcrumb/>
        <Form />    
        <Counter />
         <ContentWithImages/>
         <FollowYt/>
         <DoctorBite/>
         <PatientReviews/>
         <GetInTouch/>
      </main>
    </div>
  )
}
